import { Route, Routes } from "react-router-dom";
import ReactDOM from "react-dom";
import ko from "axe-core/locales/ko.json";
import React, { useContext } from "react";
import "../src/style/adminStyle/admin.css";
import Header from "./pages/UserPage/Layout/Header";
import Footer from "./pages/UserPage/Layout/Footer";
import AirService from "./pages/UserPage/Menu/AirService";
import useDeviceLogger from "./hooks/useDeviceLogger";

import "./style/pc.css";
import "./style/mobile.css";
import { DeclareProvider } from "./context/users/DeclareContext";
import { DataProvider } from "./context/users/DataContextCopy";
import { LoginContext, LoginProvider } from "./context/users/LoginContextCopy";
import { SurveysProvider } from "./context/users/SurveysContext";

import Declare from "./pages/declare/Declare";
import DeclareList from "./pages/declare/DeclareList";
import DeclareAnswer from "./pages/declare/user/answer/DeclareAnswer";
import Forecast from "./pages/UserPage/Menu/Forecast";
import AdminLogin from "./pages/AdminPage/login/AdminLogin";
import NotFound from "./pages/UserPage/Layout/NotFound";
import Survey from "./pages/UserPage/Menu/Survey";
import AsconMain from "./pages/UserPage/ascon/AsconMain";

const App = () => {
  // 디바이스 접속 로그
  useDeviceLogger();

  // 빌드시 콘솔 삭제
  if (process.env.NODE_ENV === "production") {
    console = window.console || {};
    console.log = function no_console() {};
    console.warn = function no_console() {};
    console.error = function () {};
  }

  // 개발 버전에서만 작동되도록 조건 처리
  if (process.env.NODE_ENV.includes("development")) {
    import("@axe-core/react").then(
      ({ default: axe }) =>
        axe(React, ReactDOM, 1000, {
          locale: ko,
        }),
      ({ message }) => console.error(message),
    );
  }

  return (
    <>
      <LoginProvider>
        <DeclareProvider>
          <SurveysProvider>
            <DataProvider>
              <div>
                <Header />
                <RoutesWrapper />
                <Footer />
              </div>
            </DataProvider>
          </SurveysProvider>
        </DeclareProvider>
      </LoginProvider>
    </>
  );
};

const RoutesWrapper = () => {
  const { isLoginState, login } = useContext(LoginContext);

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/forecast" element={<Forecast />} />
      <Route path="/airService" element={<AirService />} />
      <Route path="/" element={<Declare />} />
      <Route path="/declareList" element={<DeclareList />} />
      <Route path="/declarelist/answer" element={<DeclareAnswer />} />
      <Route path="/survey" element={<Survey />} />
      <Route path="/login" element={<AdminLogin />} />
      <Route path="*" element={<NotFound />} />

      {/* Private routes based on user role */}
      {isLoginState && <Route path="/ascon" element={<AsconMain />} />}
    </Routes>
  );
};

export default App;
